import { useState, useEffect } from 'react';

export const useReportPrint = (shop, tCommon, tReport, DateTimeHelpers) => {
  const [reportToPrint, setReportToPrint] = useState(null);

  useEffect(() => {
    if (reportToPrint) {
      document.body.classList.add('printing-invoice');
      setTimeout(() => {
        window.print();
        document.body.classList.remove('printing-invoice');
        setReportToPrint(null);
      }, 500);
    }
  }, [reportToPrint]);

  const handlePrint = (title, dateFrom, dateTo, headerData, filteredItems, summary) => {
    const excludedColumns = ['download', 'actions', 'view_Items', 'viewItems'];
    const reportData = {
      title: title,
      dateRange: tReport('{{from}} to {{to}}', {
        from: DateTimeHelpers.convertDateToDMY(dateFrom),
        to: DateTimeHelpers.convertDateToDMY(dateTo),
      }),
      headers: headerData
        .filter((h) => !excludedColumns.includes(h.id))
        .map((h) => ({
          id: h.id,
          label: h.label,
          className:
            h.id === 'bill_no' ||
            h.id === 'name' ||
            h.id === 'item_name' ||
            h.id === 'staff_name' ||
            h.id === 'customer' ||
            h.id === 'customer_name' ||
            h.id === 'customer_mobile' ||
            h.id === 'customer_tax_id'
              ? 'text-left'
              : h.type === 'floatAmount' ||
                h.id === 'total' ||
                h.id === 'tax_amount' ||
                h.id === 'cess_amount' ||
                h.id === 'net_amount' ||
                h.id === 'discount' ||
                h.id === 'profit' ||
                h.id === 'tax' ||
                h.id === 'cess' ||
                h.id === 'discount_applied_on_items'
              ? 'text-right'
              : 'text-center',
        })),
      rows: filteredItems.map((item) => {
        const row = {};
        headerData.forEach((header) => {
          if (excludedColumns.includes(header.id)) {
            return;
          }
          if (header.id === 'vendor') {
            row[header.id] = item?.vendor?.name ?? item?.vendor_name_old ?? '-';
          } else if (header.viewRender) {
            row[header.id] = header.viewRender(item);
          } else {
            row[header.id] = item[header.id];
          }
        });
        return row;
      }),
      summary: summary || {},
    };
    setReportToPrint(reportData);
  };

  return { reportToPrint, handlePrint };
};
